import { makeVar } from '@apollo/client';

export type AppVariables = {
  isWebinar?: boolean;
  isAutomationAccount?: boolean;
  publicPage?: boolean;
  initialLocale?: string;
  eventId?: string;
  attendeeId?: string;
  contactId?: string;
  accountMappingId?: string;
  environmentName?: string;
  isGPCEnabled?: boolean;
};

export const appVariables = makeVar<AppVariables>({});

export enum Product {
  WEBINAR = 'Cvent Webinar',
  ATTENDEE_HUB = 'Attendee Hub'
}
